import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
@Component({
    template: `<router-outlet></router-outlet>`,
  standalone: false
})
export class DeclarationOfConformityComponent implements OnInit {
    constructor() { }

    ngOnInit(): void {}
}